<template>
    <div class="center">
        <div class="about">
            <h1>Impressum</h1>
            <h3>
                David Neugebauer<br>
                Blankstraße 45<br>
                42119 Wuppertal<br>
                Telefon: +49 0202 94670375<br>
                E-Mail: info@sonnenwirbel.com
            </h3>

            <h3>
                Du hast Fragen oder Schwierigkeiten mit der App?<br>
                Dann schick mir gerne eine E-Mail und ich helfe dir!
            </h3>
            <h3>
                Mehr Infos zu mir auf: <a href="https://sonnenwirbel.com" style="font-size: 1rem;">www.sonnenwirbel.com</a>
            </h3>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ImpressumPage'
}
</script>

<style scoped>
/* Specific styles for ImpressumPage can go here if needed */
/* However, we are relying on global.css for .center and .about */
a {
    color: #007bff; /* Copied from the old impressum.html inline style, can be moved to global if preferred */
    text-decoration: none;
}

a:hover {
    text-decoration: underline; /* Copied from the old impressum.html inline style */
}
</style> 